import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createRequestPowerPlayerWindowOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { HtmlAreaButton } from './htmlAreaButton';
export const HtmlAreaShowPowerPlayerStatusButton = ({ label }) => {
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createRequestPowerPlayerWindowOutbound());
    }, [socketSend]);
    return _jsx(HtmlAreaButton, { label: label, onClick: onClick });
};
